export class Markup {
  markupType: string;
  markupDisabled: boolean;
  markupDollar: number;
  markupMultiplier: number;
  productTypeMarkup: { productType: string; markupDollar: number | null; markupMultiplier: number | null }[];

  constructor() {
    this.markupType = 'multiplier';
    this.markupMultiplier = 2;
    this.markupDollar = 100;
    this.markupDisabled = false;
    this.productTypeMarkup = [];
  }
}
